import { SvgIcon, SvgIconProps } from "@mui/material";

export default function BookIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 19">
      <path
        fillRule="nonzero"
        d="M24.1 3.167c.496 0 .9.397.9.884v14.064c0 .27-.123.523-.339.691a.911.911 0 0 1-.763.172c-2.158-.484-5.945-1.045-9.536-.181 2.076-1.931 5.009-2.273 6.787-2.277 1.267-.003 2.297-1.016 2.297-2.259V3.167zm-22.546 0V14.26c0 1.243 1.03 2.256 2.297 2.259 1.778.004 4.71.346 6.787 2.277-3.591-.864-7.378-.303-9.536.18a.91.91 0 0 1-.763-.17.874.874 0 0 1-.339-.692V4.051c0-.487.404-.884.9-.884h.654zM3.569 0c2.127.005 5.995.482 8.008 3.626a.828.828 0 0 1 .125.447v13.871c-2.452-2.488-6.008-2.917-8.13-2.922-.503-.001-.912-.397-.912-.884V.884c0-.237.095-.46.268-.627A.913.913 0 0 1 3.567 0zm17.864 0c.241 0 .468.091.64.257.172.167.267.39.267.627v13.255c0 .486-.409.882-.912.883-2.122.005-5.678.434-8.13 2.922V4.074c0-.165.043-.32.125-.448C15.436.482 19.305.005 21.431 0z"
      />
    </SvgIcon>
  );
}
